import React from 'react';

import { coeFiltersQuery, coeAssetsQuery } from '../../../../../store/customerAssetDetail/selector';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { DynamicProductTable } from '../_dynamic';

import { tableHead } from './constants';
import ProductItem from './item';

export const CoeTable: React.FC<DynamicAssetTableProps> = (props) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={coeAssetsQuery}
      filtersQuery={coeFiltersQuery}
      tableHeadItems={tableHead}
      tabletColumns={5}
      mobileColumns={3}
      mobileRows={2}
      mobileFields={[
        { key: 'operationNormalized', label: 'Operações' },
        { key: 'productNameNormalized', label: 'Ativo' },
        { key: 'expirationDateNormalized', label: 'Data da vencimento' },
        { key: 'appliedValueNormalized', label: 'Valor aplicado' },
        { key: 'returnPercentageNormalized', label: 'Retorno' },
        { key: 'markingValueNormalized', label: 'Valor marcação' },
      ]}
    />
  );
};
